<script>
  import { fade, fly } from "svelte/transition";

  export let closeWallet;
</script>

<div class="wallet-layout" in:fade out:fade>
  <div
    style="position:absolute; background-color: rgba(0, 0, 0, 0.7); width: 100vw; height:100vh;opacity: 0.7;"
    on:click={closeWallet}
  />
  <div
    class="no-wallet-container "
    in:fly={{ y: 200, duration: 300 }}
    out:fly={{ y: 200, duration: 300 }}
  >
    <span class="wallet-title" style="margin:84px 0 20px 0"
      >No Wallets installed</span
    >
    <span>In Order to connect a wallet,</span>
    <span>first install one of your brower</span>

    <span style="margin-top: 40px"
      >Try <a href="https://metamask.io/download/" target="_blank">Metamask</a>
      or
      <a href="https://www.coinbase.com/wallet" target="_blank">Coinbase</a
      ></span
    >
    <img
      class="close"
      src="images/close.png"
      alt="close"
      on:click={closeWallet}
    />
  </div>
</div>

<style>
  a {
    color: white;
  }
  .close {
    width: 30px;
    top: 18px;
    right: 18px;
    padding: 5px;
    position: absolute;
    cursor: pointer;
  }
  .close:hover {
    filter: brightness(2);
  }

  .wallet-layout {
    width: 100%;
    height: 100vh;
    position: fixed;
    display: grid;
    place-items: center;
    z-index: 3;
  }
  .no-wallet-container {
    width: 100%;
    width: 440px;
    height: 313px;
    background: #111111;
    border: 1px solid #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 0 39px; */
    position: relative;
  }

  .wallet-title {
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
  }

  .close {
    width: 30px;
    top: 18px;
    right: 18px;
    padding: 5px;
    position: absolute;
    cursor: pointer;
  }
  .close:hover {
    filter: brightness(2);
  }

  @media (max-width: 600px) {
    .no-wallet-container {
      width: 100%;
    }
  }
</style>
